import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { useFetchStatus } from 'src/hooks/useFetchStatus';


const useAuthenticatedImage = ({ url }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [ imageUrl, setImageUrl ] = useState(null);

  const fetchImageWithToken = async () => {
    if (!url) {
      throw new Error('Missing image URL');
    }

    const token = await getAccessTokenSilently();

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get('content-type');
    let blob;
    if (contentType.includes('application/json')) {
      const { data: presignedUrl } = await response.json();
      const file = await fetch(presignedUrl, {
        method: 'GET',
      });
      blob = await file.blob();
    } else {
      blob = await response.blob();
    }

    const blobUrl = URL.createObjectURL(blob);

    setImageUrl(blobUrl);
  };

  const { isLoading, hasError, handleConfirm } = useFetchStatus({
    confirmFn: fetchImageWithToken,
  });

  useEffect(() => {
    if (url) {
      handleConfirm();
    }

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [ url ]); // eslint-disable-line react-hooks/exhaustive-deps

  return { imageUrl, isLoading, hasError, refetch: handleConfirm };
};


export { useAuthenticatedImage };
